import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect } from 'react'
import { BallTriangle } from 'react-loader-spinner';
import ReactQuill from 'react-quill';
import { Link, useParams } from 'react-router-dom';
import DocumentsService from '../../services/DocumentsService';
import {Trans} from "@lingui/macro";


const ForSpecialistsRecsFromId: FC = () => {
    const { nos, recId } = useParams();
    const [recommendation, setRecommendation] = useState<any>({});
    const [fix, setFix] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);


    const getRecommendation = async () => {
        try {
            const res = await DocumentsService.getRecommendation(Number(recId));
            setRecommendation(res.data);
            setLoader(false);
        } catch (e) {
            setRecommendation({id: recId, name: 'Страница не найдена', recommendation: ''});
            setLoader(false);
        }
    }

    useEffect(() => {
        setLoader(true);
        getRecommendation();
        setFix(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fix]);


    return (loader ? <div className='row justify-content-center'><div className='col-md-2 mt-5'><BallTriangle color="#1d7ea7" height={90} width={90} /></div></div> :
        <div className="m-3">
            <div>
                <Link to={`/specialist/recs/${nos}`}><button className="btn btn-light" ><i className="icon arrow-left"></i><Trans>Back</Trans></button></Link>
            </div>
            <h6 className='pt-3 text-center'>{recommendation['name']}</h6>
            <ReactQuill
                    value={recommendation['recommendation']}
                    className='react-quill'
                    readOnly={true}
                    theme="bubble"
                />
        </div>
    );
};

export default observer(ForSpecialistsRecsFromId);